import {Box, Typography} from '@yandex-delivery/blocks'
import clsx from 'clsx'

import * as styles from './OrderNumIcon.classes'

/** Пропсы компонента OrderNumIcon */
type OrderNumIconProps = {
  /** Названия классов */
  className?: string
  /** Цвет иконки */
  color: 'black' | 'gray'
  /** Число в иконке */
  num: number
}

/**
 * Скруглённый квадрат с числом.
 */
export function OrderNumIcon({className, color, num}: OrderNumIconProps) {
  return (
    <Box
      alignItems="center"
      className={clsx(styles.orderNumIcon, className, {
        [styles.gray]: color === 'gray',
        [styles.black]: color === 'black',
      })}
      justifyContent="center"
    >
      <Typography color={color === 'gray' ? 'main' : 'invert'} variant="body1">
        {num}
      </Typography>
    </Box>
  )
}
